module.exports = __webpack_public_path__ + "img/seo.d47a20a5.png";